<template>
  <div class="new-invoice-infos">
    <div class="form-box">
      <!-- 订单金额 -->
      <!-- <div class="form-line">
        <div class="form-field single-item">
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">订单金额：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                v-model="formData.invoice_price"
                @input="inputInvoicePrice($event); onFieldBlur();"
                name="invoicePrice"
                class="invoice-price"
                placeholder="请输入需开票订单金额"
                :class="{
                  error:
                    formDataError.invoice_price.required ||
                    formDataError.invoice_price.pattern ||
                    formDataError.invoice_price.maxOrMin
                }"
              />
              <div class="input-tips">
                ≤ {{ (totalOrderPrice / 100).toFixed(2) }} 元
              </div>
            </div>
            <div class="err-tips" v-if="formDataError.invoice_price.required">
              请输入需开票订单金额
            </div>
            <div class="err-tips" v-if="formDataError.invoice_price.pattern">
              仅可输入大于1的数字且最多2位小数
            </div>
            <div class="err-tips" v-if="formDataError.invoice_price.maxOrMin">
              输入金额需大于1，且小于等于已选订单金额
            </div>
          </div>
        </div>
      </div> -->

      <!-- 发票类别 -->
      <div class="form-line">
        <div class="form-field">
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">发票类别：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <el-radio-group
                name="invoiceType"
                v-model="formData.invoice_type"
              >
                <el-radio :label="0">电子发票</el-radio>
                <!-- <el-radio :label="1">纸质发票（顺丰到付）</el-radio> -->
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>

      <!-- 地址区域 -->
      <div class="address-section" v-if="formData.invoice_type === 1">

        <!-- 收货人 & 联系电话-->
        <div class="form-line">
          <!-- 收货人 -->
          <div class="form-field">
            <div class="field-label">
              <div class="field-required">*</div>
              <div class="label-text">收货人：</div>
            </div>
            <div class="field-ctrl">
              <div class="ctrl-wrapper">
                <input
                  type="text"
                  name="expressAddressee"
                  maxlength="15"
                  v-model="formData.express.addressee"
                  @input="onFieldBlur"
                  class="express-addressee"
                  placeholder="请输入收货人"
                  :class="{ 'error': formDataError.express.addressee.required }"
                />
              </div>
              <div class="err-tips" v-if="formDataError.express.addressee.required">请输入收货人</div>
            </div>
          </div>

          <!-- 联系电话 -->
          <div class="form-field">
            <div class="field-label">
              <div class="field-required">*</div>
              <div class="label-text">联系电话：</div>
            </div>
            <div class="field-ctrl">
              <div class="ctrl-wrapper">
                <input
                  type="text"
                  name="mobilePhone"
                  maxlength="11"
                  v-model="formData.express.mobile_phone"
                  @input="onFieldBlur"
                  class="mobile-phone"
                  placeholder="请输入联系电话"
                  :class="{
                    error:
                      formDataError.express.mobile_phone.required ||
                      formDataError.express.mobile_phone.pattern
                  }"
                />
              </div>
              <div class="err-tips" v-if="formDataError.express.mobile_phone.required">
                请输入联系电话
              </div>
              <div class="err-tips" v-if="formDataError.express.mobile_phone.pattern">
                请输入正确的手机号码
              </div>
            </div>
          </div>
        </div>

        <!-- 收货地址 & 详细地址 -->
        <div class="form-line">
          <!-- 收货地址 -->
          <div class="form-field">
            <div class="field-label">
              <div class="field-required">*</div>
              <div class="label-text">收货地址：</div>
            </div>
            <div class="field-ctrl">
              <div class="ctrl-wrapper">
                <el-select
                  v-model="formData.express.province_code"
                  placeholder="省"
                  name="provinceCode"
                  size="medium"
                  @change="
                    formData.express.city_code = '';
                    formData.express.county_code = '';
                    onFieldBlur();
                  "
                  :class="{ error: formDataError.express.province_code.required }"
                >
                  <el-option
                    :label="province"
                    :value="parseInt(index)"
                    v-for="(province, index) in pcds[86]"
                    :key="index"
                  ></el-option>
                </el-select>

                <el-select
                  v-model="formData.express.city_code"
                  name="cityCode"
                  placeholder="市"
                  @change="formData.express.county_code = ''; onFieldBlur();"
                  :class="{ error: formDataError.express.city_code.required }"
                >
                  <el-option
                    :label="city"
                    :value="parseInt(index)"
                    v-for="(city, index) in pcds[formData.express.province_code]"
                    :key="index"
                  ></el-option>
                </el-select>

                <el-select
                  v-model="formData.express.county_code"
                  name="countyCode"
                  placeholder="区"
                  @change="onFieldBlur"
                  :class="{ error: formDataError.express.county_code.required }"
                >
                  <el-option
                    :label="district"
                    :value="parseInt(index)"
                    v-for="(district, index) in pcds[formData.express.city_code]"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="err-tips"
                v-if="
                  formDataError.express.province_code.required ||
                    formDataError.express.city_code.required ||
                    formDataError.express.county_code.required
                "
              >
                请选择收货地址
              </div>
            </div>
          </div>

          <!-- 详细地址 -->
          <div class="form-field detail-addrss-field">
            <div class="field-ctrl">
              <div class="ctrl-wrapper">
                <input
                  type="text"
                  name="detailAddress"
                  maxlength="50"
                  v-model="formData.express.detail_address"
                  @input="onFieldBlur"
                  class="detail-address"
                  placeholder="请输入详细地址"
                  :class="{
                    error: formDataError.express.detail_address.required
                  }"
                />
              </div>
              <div
                class="err-tips"
                v-if="formDataError.express.detail_address.required"
              >
                请输入详细地址
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 抬头类型 -->
      <div class="form-line">
        <div class="form-field">
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">抬头类型：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <el-radio-group name="headerType" v-model="formData.header_type">
                <el-radio :label="0">企业</el-radio>
                <el-radio :label="1">个人</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>

      <!-- 发票抬头 & 公司税号-->
      <div class="form-line">
        <!-- 发票抬头 -->
        <div
          class="form-field"
          :class="{ 'single-item': formData.header_type === 1 }"
        >
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">发票抬头：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                class="invoce-header"
                name="invoiceHeader"
                maxlength="100"
                v-model="formData.invoice_header"
                @input="onFieldBlur"
                placeholder="请输入发票抬头"
                :class="{ error: formDataError.invoice_header.required }"
              />
            </div>
            <div class="err-tips" v-if="formDataError.invoice_header.required">
              请输入发票抬头
            </div>
          </div>
        </div>

        <!-- 公司税号 -->
        <div class="form-field" v-if="formData.header_type === 0">
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">公司税号：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                name="taxerIdNum"
                maxlength="18"
                v-model="formData.taxer_id_num"
                class="taxer-id-num"
                placeholder="请输入纳税人识别号"
                @input="onFieldBlur"
                :class="{
                  error:
                    formDataError.taxer_id_num.required ||
                    formDataError.taxer_id_num.pattern
                }"
              />
            </div>
            <div class="err-tips" v-if="formDataError.taxer_id_num.required">
              请输入公司税号
            </div>
            <div class="err-tips" v-if="formDataError.taxer_id_num.pattern">
              请输入正确的公司税号，格式为字母+数字
            </div>
          </div>
        </div>
      </div>

      <!-- 备注信息 & 电子邮箱 -->
      <div class="form-line">
        <!-- 备注信息 -->
        <div
          class="form-field"
          :class="{ 'single-item': formData.invoice_type === 1 }"
        >
          <div class="field-label">
            <div class="label-text">备注信息：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                name="memo"
                maxlength="50"
                v-model="formData.memo"
                class="peer-memo"
                placeholder="有特殊需求请备注"
              />
            </div>
          </div>
        </div>

        <!-- 电子邮箱 -->
        <div class="form-field" v-if="formData.invoice_type === 0">
          <div class="field-label">
            <div class="label-text">电子邮箱：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                class="email"
                name="email"
                maxlength="50"
                v-model="formData.email"
                @input="onFieldBlur"
                placeholder="请输入正确邮箱地址，用于接收发票"
                :class="{ error: formDataError.email.pattern }"
              />
            </div>
            <div class="err-tips" v-if="formDataError.email.pattern">
              请输入正确邮箱地址
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部操作 -->
    <div class="bottom-handles">
      <!-- 操作提示 -->
      <div class="handle-tips">
        <p>
          1、所开发票为增值税普通发票，内容为“旅游服务*代办签证费”；
        </p>
        <p>
          2、开具电子发票需三至五个工作日，请留意公众号消息通知开票结果。
          <!-- 开具电子发票需三至五个工作日，纸质发票需根据物流信息而定，请留意公众号消息通知开票结果。 -->
        </p>
      </div>

      <!-- 价格信息 -->
      <div class="price-info">
        <div class="price-label">开票金额</div>
        <div class="price-sign">¥</div>
        <div class="price-number">{{ combineInvoicePrice }}</div>
      </div>

      <!-- 操作按钮 -->
      <button class="pay-now-btn" @click="payNow">{{ isHistroy ? `服务费（¥ ${formatNeedPayAmount}）` : '提交' }}</button>
    </div>
    <!-- 充值弹窗 -->
    <recharge-dialog
      v-model="showRechargeDialog"
      @recharge-success="visaPeerQuery"
      from="invoice"
    >
    </recharge-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import { mapState, mapActions } from 'vuex';
import rechargeDialog from '@/components/common/recharge-dialog';
import invoiceService from '../../../services/invoice-service';
import invoiceApi from '../../../api/invoice-api';
import utils from '../../../libs/utils';

export default {
  name: 'new-invoice-infos',
  components: {
    rechargeDialog,
  },
  props: {
    pcds: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    selectedOrders: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    totalOrderPrice: {
      type: Number,
      required: true,
      default: 0,
    },
    taxPoint: {
      type: Number,
      required: true,
      default: 0,
    },
    isHistroy: {
      type: Boolean,
      default: false,
    },
    peerInfo: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    peerAccountInfo: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formData: {
        invoice_price: '', // 开票金额
        invoice_type: 0, // 发票类型
        header_type: 0, // 抬头类型
        invoice_header: '', // 发票抬头
        taxer_id_num: '', // 纳税人识别好
        memo: '', // 备注
        email: '', // 邮箱
        express: {
          addressee: '', // 收货人
          mobile_phone: '', // 联系电话
          province_code: '', // 省
          city_code: '', // 市
          county_code: '', // 区
          detail_address: '', // 详细地址
        },
      },
      formSubmitted: false,
      formDataError: invoiceService.getFormDataError(),
      showRechargeDialog: false, // 显示充值弹窗
    };
  },
  watch: {
    totalOrderPrice(val) {
      this.formData.invoice_price = val ? val / 100 : 0;
    },
  },
  computed: {
    ...mapState('user', ['peerData']),

    // 需要支付的金额
    needPayAmount() {
      if (this.formData.invoice_price) {
        return Math.ceil(+this.formData.invoice_price * this.taxPoint);
      }
      return 0;
    },
    // 需要支付的金额格式化显示
    formatNeedPayAmount() {
      return (this.needPayAmount / 100).toFixed(2);
    },

    // 订单开票金额+税点
    combineInvoicePrice() {
      if (this.formData.invoice_price) {
        

        // 用分表示都输入开票金额
        const invoicePriceInCent = utils.mul(+this.formData.invoice_price, 100);

        // 用分表示的费率
        const taxInCent = invoicePriceInCent * (this.taxPoint / 100);


        // 用元表示的总价
        return (Math.ceil(invoicePriceInCent + taxInCent)) / 100;
      }
      return '0.00';
    },
  },
  methods: {
    ...mapActions('user', ['visaPeerQuery']),

    // 限制输入
    inputInvoicePrice($event) {
      const value = $event.target.value.replace(/[^\d^\\.]/g, '');
      this.formData.invoice_price = value;
    },

    // 在提交后才开启失焦验证
    onFieldBlur() {

      if (this.formSubmitted) {
        // 验证下面的表单
        const { newFormDataError } = invoiceService.validateFormData(
          true, this.formData, this.totalOrderPrice, this.pcds,
        );

        // 设置表单错误
        this.formDataError = newFormDataError;
      }
    },

    // 立即支付
    payNow() {
      this.formSubmitted = true;

      // 验证选择订单
      if (this.selectedOrders.length === 0) {
        return utils.msg.error('请先选择要开发票的订单');
      }

      // 验证下面的表单
      const { haveFieldError, newFormDataError } = invoiceService.validateFormData(
        true, this.formData, this.totalOrderPrice, this.pcds,
      );

      // 设置表单错误
      this.formDataError = newFormDataError;

      // 判断是否为金额错误，需要提示用户，因为没有对应的输入框了
      if (newFormDataError.invoice_price.required || newFormDataError.invoice_price.pattern || newFormDataError.invoice_price.maxOrMin) {
        utils.msg.error('选择开票的订单金额需大于1');
      }

      // 字段报错，返回
      if (haveFieldError) return;

      // 检查余额
      Promise.resolve(this.needPayAmount ? this.checkBalance() : Promise.resolve()).then(() => {
        // 构建参数
        const params = invoiceService.createParams(undefined, this.formData, this.selectedOrders, this.needPayAmount);

        const loadingInstance = Loading.service({
          text: '处理中',
        });

        invoiceApi.invoiceSubmit(params).then((res) => {
          if (res.cash_fee) {
            invoiceApi.invoicePay({
              cash_fee: res.cash_fee,
              payment_type: 2,
              order_invoice_id: res.order_invoice_id,
            }).then(() => {
              loadingInstance.close();

              // 成功就到成功页
              this.$router.replace({ name: 'payInvoiceSuccess' });
            }).catch((err) => {
              loadingInstance.close();

              utils.msg.error(
                err && err.msg ? err.msg : '支付失败, 请重试',
              );
            });
          } else {
            loadingInstance.close();
            this.$router.replace({ name: 'payInvoiceSuccess', query: { is_apply: !this.isHistroy } });
          }

        }).catch((err) => {
          loadingInstance.close();
          console.log(err);
          if (err && err.msg) {
            utils.msg.error(err.msg || '提交发票信息失败, 请重试');
            if (err.msg.indexOf('支付价格已变更') > -1) {
              this.$emit('changeInvoicePercent');
            }
          }
        });
      });

    },

    // 检查余额
    checkBalance() {
      return new Promise((resolve, reject) => {
        this.visaPeerQuery().then(() => {
          if (this.needPayAmount > this.peerData.balance_amount) {
            this.$confirm('即将使用余额支付服务费，是否确认支付？', '提示', {
              confirmButtonText: '余额不足，请充值',
              cancelButtonText: '取消',
            }).then(() => {
              this.showRechargeDialog = true;
              reject();
            }).catch(() => {
              reject();
            });
          } else {
            this.$confirm('即将使用余额支付服务费，是否确认支付？', '提示', {
              confirmButtonText: '确认支付',
              cancelButtonText: '取消',
            }).then(() => {
              resolve();
            }).catch(() => {
              reject();
            });
          }
        });

      });
    },

    // 获取默认的发票信息
    getDefaultInvoiceInfos() {
      invoiceApi.invoiceQuery({}).then((data) => {
        this.formData = {
          invoice_price: '', // 开票金额
          invoice_type: 0, // 发票类型
          header_type: typeof data.header_type !== 'undefined' ? data.header_type : 0, // 抬头类型
          invoice_header: data.invoice_header ? data.invoice_header : '', // 发票抬头
          taxer_id_num: data.taxer_id_num ? data.taxer_id_num : '', // 纳税人识别好
          memo: '', // 备注
          email: data.email ? data.email : '', // 邮箱
          express: {
            addressee: this.peerAccountInfo.name, // 收货人
            mobile_phone: this.peerAccountInfo.phone_number, // 联系电话
            province_code: this.peerInfo.province_code, // 省
            city_code: this.peerInfo.city_code, // 市
            county_code: this.peerInfo.county_code, // 区
            detail_address: this.peerInfo.detail_address, // 详细地址
          },
        };
      });
    },
  },
  created() {
    this.getDefaultInvoiceInfos();
  },
};
</script>

<style lang="less" scoped>
.new-invoice-infos {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 32px;
  .form-box {
    display: flex;
    flex-direction: column;
    .form-line {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 40px;
      }
      .form-field {
        display: flex;
        align-items: center;
        flex: 1;
        & + .form-field {
          margin-left: 30px;
        }
        &.single-item {
          flex: none;
          width: 521px;
        }
        .field-label {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 14px;
          line-height: 16px;
          width: 83px;
          flex-shrink: 0;
          .field-required {
            color: #f4455c;
            margin-right: 3px;
          }
          .label-text {
            color: #2f333d;
          }
        }
        .field-ctrl {
          display: flex;
          align-items: center;
          flex: 1;
          position: relative;
          height: 40px;
          .ctrl-wrapper {
            display: flex;
            align-items: center;
            position: relative;
            flex: 1;
            input {
              width: 50%;
              padding: 0 12px;
              height: 40px;
              border-radius: 2px;
              border: 1px solid #dee2e6;
              color: #2F333D;
              flex: 1;
              font-size: 14px;
              outline: 0;
              &:focus {
                border: 1px solid #599FFF;
              }
              &.invoice-price {
                padding-right: 110px;
              }
              &.error {
                border-color: #ff6464;
              }
            }
            /deep/ .el-select {
              margin-right: 12px;
              input {
                height: 40px;
              }
              &.error {
                input {
                  border-color: #ff6464;
                }
              }
              &:last-child {
                margin-right: 0;
              }
            }
            .input-tips {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: 12px;
              font-size: 14px;
              font-weight: 400;
              color: #c9cdd1;
              line-height: 14px;
            }
          }
          .err-tips {
            display: flex;
            position: absolute;
            left: 12px;
            bottom: -20px;
            font-size: 12px;
            font-weight: 400;
            line-height: 12px;
            color: #f4455c;
          }
        }
      }
    }
    .address-section {
      margin-top: -24px;
      margin-left: 83px;
      background: #FAFBFC;
      border-radius: 2px;
      border: 1px solid #DEE2E6;
      display: flex;
      flex-direction: column;
      padding: 0 24px;
      margin-bottom: 24px;
      .form-line {
        &:first-child {
          margin-top: 24px;
        }
        &:last-child {
          margin-bottom: 24px;
        }
        .detail-addrss-field {
          margin-left: 12px;
        }
      }
    }
  }
  .bottom-handles {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 82px;
    padding: 0 24px;
    background: #ffffff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
    display: flex;
    align-items: center;
    .handle-tips {
      display: flex;
      flex-direction: column;
      flex: 1;
      p {
        font-size: 12px;
        font-weight: 400;
        color: #91999f;
        line-height: 20px;
      }
    }
    .price-info {
      display: flex;
      align-items: baseline;
      .price-label {
        color: #2f333d;
        font-size: 14px;
      }
      .price-sign {
        margin-left: 8px;
        font-size: 20px;
        font-weight: 500;
        color: #2F333D;
        line-height: 20px;
      }
      .price-number {
        margin-left: 2px;
        font-size: 20px;
        color: #2F333D;
        line-height: 20px;
        font-weight: 500;
      }
    }
    .pay-now-btn {
      cursor: pointer;
      margin-left: 20px;
      width: 200px;
      height: 50px;
      background: #ff8033;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: #ffffff;
      line-height: 22px;
      outline: none;
      border: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice-manage/components/new-invoice-infos.vue